<template>
  <div
    class="result"
    :class="pageType=='trade'||pageType=='app'?'':'position'"
  >
    <div class="layout">
      <div class="sucPrompt">
        <img src="@/assets/images/template/success.png">
        <span>提现申请成功，系统将尽快处理</span>
      </div>
      <div
        v-if="withdrawalData&&withdrawalData.bankName"
        class="orderList"
      >
        <ul>
          <li>
            <p>提现至</p>
            <span v-if="withdrawalData.isA9==0">{{ withdrawalData.bankName }}(尾号{{ (withdrawalData.bankNum).replace(/^(\d{0})\d+(\d{4})$/, "$2") }})</span>
            <span v-else>{{ withdrawalData.bankName }}</span>
          </li>
          <li>
            <p>提现金额</p><span>{{ withdrawalData.amount }}美元</span>
          </li>
          <li>
            <p>手续费</p><span>{{ withdrawalData.fee }}美元</span>
          </li>
          <li>
            <p>实际到账金额</p><span>{{ parseFloat(withdrawalData.rate*(withdrawalData.amount-withdrawalData.fee)).toFixed(2) }}{{ withdrawalData.isA9==0?"人民币":"USDT" }}（仅供参考）</span>
          </li>
        </ul>
      </div>
      <div
        v-if="pageType=='trade'||pageType=='app'"
        class="tradeBtn"
      >
        <p
          class="submit"
          @click="goAppMarket"
        >去交易</p>
        <span
          v-if="sourceType!='old'"
          @click="goAppTrade"
        >查看可用资金</span>
      </div>
      <div
        v-else
        class="btnItem"
      >
        <span
          class="leftBtn"
          @click="goRecord"
        >查看记录</span>
        <span
          v-sa="{'ClickWithdrawals':{'PType':pageType=='app'?'app端':pageType=='trade'?'H5交易':'用户中心','AccountType':'真实账户','entry':'取款成功-取款'}}"
          class="rightBtn"
          @click="goWithdrawal"
        >继续提现</span>
      </div>
    </div>
    <!--<div class="tradeInfo" v-if="pageType=='trade'||pageType=='app'">
        <div class="title"><span>大家都在买</span><p>更多</p></div>
        <div class="tradeCon">
            <ul>
                <li>
                    <div class="name"><span>澳元美元</span><p>AUDUSD</p></div>
                    <div class="price rise"><span>0.68970</span><p></p></div>
                </li>
                <li>
                    <div class="name"><span>澳元美元</span><p>AUDUSD</p></div>
                    <div class="price fall"><span>0.68970</span><p></p></div>
                </li>
                <li>
                    <div class="name"><span>澳元美元</span><p>AUDUSD</p></div>
                    <div class="price fall"><span>0.68970</span><p></p></div>
                </li>
                <li>
                    <div class="name"><span>澳元美元</span><p>AUDUSD</p></div>
                    <div class="price fall"><span>0.68970</span><p></p></div>
                </li>
            </ul>
        </div>
    </div>-->
    <Chat />
    <ToHome />
  </div>
</template>

<script>
require('@/assets/css/result.css')
import Chat from '@/view/module/Chat.vue'
import ToHome from '@/view/module/ToHome.vue'
import utils from '@/utils/tradeDataUtil'
import { mapState } from 'vuex'
export default {
  name: 'WithdrawalResult',
  components: { Chat, ToHome },
  computed: {
    ...mapState(['withdrawalData', 'pageType', 'sourceType'])
  },
  mounted() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
    this.$fireBase.logEvent('withdraw_success', {
      'platform_type': this.pageType == 'app' ? 'app端' : this.pageType == 'trade' ? 'H5交易' : '用户中心',
      'bank_type': this.bankName,
      'time': utils.getThisTime(),
      'withdraw_amount': this.withdrawalData.amount,
      'real_amount': Number(this.withdrawalData.rate * this.withdrawalData.amount).toFixed(2),
      'url': window.location.href,
      'is_success': 'true'
    })
  },
  activated() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    goRecord() {
      this.$bus.$emit('loading', false)
      this.$store.dispatch('setTabIndex', 1)
      if (this.pageType == 'app') this.$router.push({ path: '/home/record', query: { typeName: 'withdraw' }})
      else this.$router.push({ path: '/home/record' })
    },
    goWithdrawal() {
      this.$bus.$emit('loading', false)
      this.$router.push({ path: '/home/withdrawal' })
    },
    goAppTrade() {
      window.location.href = 'https://www.cfwell.com/?intercept_trade'
    },
    goAppMarket() {
      window.location.href = 'https://www.cfwell.com/?intercept_market'
    }
  }
}
</script>
